import { NavigationFilter } from '@/types/used-cars/used-cars.types';

export const makeOptions: NavigationFilter[] = [
  {
    id: 1001,
    name: 'Audi',
    link: `/used-cars/brands/audi`,
  },
  {
    id: 1002,
    name: 'BMW',
    link: `/used-cars/brands/bmw`,
  },
  {
    id: 1003,
    name: 'Ford',
    link: `/used-cars/brands/ford`,
  },
  {
    id: 1004,
    name: 'Fiat',
    link: `/used-cars/brands/fiat`,
  },
  {
    id: 1005,
    name: 'Hyundai',
    link: `/used-cars/brands/hyundai`,
  },
  {
    id: 1006,
    name: 'Isuzu',
    link: `/used-cars/brands/isuzu`,
  },
  {
    id: 1007,
    name: 'Kia',
    link: `/used-cars/brands/kia`,
  },
  {
    id: 1008,
    name: 'Nissan',
    link: `/used-cars/brands/nissan`,
  },
  {
    id: 1009,
    name: 'Renault',
    link: `/used-cars/brands/renault`,
  },
  {
    id: 1010,
    name: 'Suzuki',
    link: `/used-cars/brands/suzuki`,
  },
  {
    id: 1011,
    name: 'Toyota',
    link: `/used-cars/brands/toyota`,
  },
  {
    id: 1012,
    name: 'Volkswagen',
    link: `/used-cars/brands/volkswagen`,
  },
];

export const bodyOptions: NavigationFilter[] = [
  {
    id: 2001,
    name: 'Hatchback',
    link: `/used-cars/hatchback-bodytype`,
  },
  {
    id: 2002,
    name: 'SUV',
    link: `/used-cars/suv-bodytype`,
  },
  {
    id: 2003,
    name: 'Sedan',
    link: `/used-cars/sedan-bodytype`,
  },
  {
    id: 2004,
    name: 'Coupe',
    link: `/used-cars/coupe-bodytype`,
  },
  {
    id: 2005,
    name: 'Double Cab Bakkie',
    link: `/used-cars/double-cab-bakkie-bodytype`,
  },
  {
    id: 2006,
    name: 'Single Cab Bakkie',
    link: `/used-cars/single-cab-bakkie-bodytype`,
  },
  {
    id: 2007,
    name: 'Cabriolet',
    link: `/used-cars/cabriolet-bodytype`,
  },
  {
    id: 2008,
    name: 'Crossover',
    link: `/used-cars/crossover-bodytype`,
  },
  {
    id: 2009,
    name: 'Bakkie Extra Cab',
    link: `/used-cars/bakkie-extra-cab-bodytype`,
  },
  {
    id: 2010,
    name: 'Single Cab Dropside',
    link: `/used-cars/single-cab-dropside-bodytype`,
  },
  {
    id: 2008,
    name: 'Fastback',
    link: `/used-cars/fastback-bodytype`,
  },
  {
    id: 2011,
    name: 'MPV',
    link: `/used-cars/mpv-bodytype`,
  },
  {
    id: 2012,
    name: 'Panel Van',
    link: `/used-cars/panel-van-bodytype`,
  },
  {
    id: 2013,
    name: 'Estate',
    link: `/used-cars/estate-bodytype`,
  },
];

export const makeOptionsDemo: NavigationFilter[] = [
  {
    id: 3001,
    name: 'Audi',
    link: `/demo/brands/audi`,
  },
  {
    id: 3002,
    name: 'BMW',
    link: `/demo/brands/bmw`,
  },
  {
    id: 3003,
    name: 'Ford',
    link: `/demo/brands/ford`,
  },
  {
    id: 3004,
    name: 'Fiat',
    link: `/demo/brands/fiat`,
  },
  {
    id: 3005,
    name: 'Hyundai',
    link: `/demo/brands/hyundai`,
  },
  {
    id: 3006,
    name: 'Isuzu',
    link: `/demo/brands/isuzu`,
  },
  {
    id: 3007,
    name: 'Kia',
    link: `/demo/brands/kia`,
  },
  {
    id: 3008,
    name: 'Nissan',
    link: `/demo/brands/nissan`,
  },
  {
    id: 3009,
    name: 'Renault',
    link: `/demo/brands/renault`,
  },
  {
    id: 3010,
    name: 'Suzuki',
    link: `/demo/brands/suzuki`,
  },
  {
    id: 3011,
    name: 'Toyota',
    link: `/demo/brands/toyota`,
  },
  {
    id: 3012,
    name: 'Volkswagen',
    link: `/demo/brands/volkswagen`,
  },
];

export const bodyOptionsDemo: NavigationFilter[] = [
  {
    id: 4001,
    name: 'Hatchback',
    link: `/demo/body-types/hatchback`,
  },
  {
    id: 4002,
    name: 'SUV',
    link: `/demo/body-types/suv`,
  },
  {
    id: 4003,
    name: 'Sedan',
    link: `/demo/body-types/sedan`,
  },
  {
    id: 4004,
    name: 'Coupe',
    link: `/demo/body-types/coupe`,
  },
  {
    id: 4005,
    name: 'Bakkie Double',
    link: `/demo/body-types/bakkie double`,
  },
  {
    id: 4006,
    name: 'Bakkie Single',
    link: `/demo/body-types/bakkie single`,
  },
  {
    id: 4007,
    name: 'Cabriolet',
    link: `/demo/body-types/cabriolet`,
  },
  {
    id: 4008,
    name: 'Hard Top',
    link: `/demo/body-types/hard top`,
  },
];

export const locationOptions: NavigationFilter[] = [
  {
    id: 5001,
    name: 'Gauteng',
    link: '/used-cars/provinces/gauteng',
  },
  {
    id: 5002,
    name: 'KwaZulu-Natal',
    link: '/used-cars/provinces/kwazulu-natal',
  },
  {
    id: 5003,
    name: 'Western Cape',
    link: '/used-cars/provinces/western-cape',
  },
  {
    id: 5004,
    name: 'Free State',
    link: '/used-cars/provinces/free-state',
  },
  {
    id: 5005,
    name: 'Northern Cape',
    link: '/used-cars/provinces/northern-cape',
  },
];

export const priceOptions: NavigationFilter[] = [
  {
    id: 6001,
    name: 'Cars under R100 000',
    link: '/used-cars/under-100000',
  },
  {
    id: 6002,
    name: 'Cars under R150 000',
    link: '/used-cars/under-150000',
  },
  {
    id: 6003,
    name: 'Cars under R200 000',
    link: '/used-cars/under-200000',
  },
  {
    id: 6004,
    name: 'Cars under R250 000',
    link: '/used-cars/under-250000',
  },
  {
    id: 6005,
    name: 'Cars under R300 000',
    link: '/used-cars/under-300000',
  },
  {
    id: 6006,
    name: 'Cars under R350 000',
    link: '/used-cars/under-350000',
  },
  {
    id: 6007,
    name: 'Cars under R400 000',
    link: '/used-cars/under-400000',
  },
  {
    id: 6008,
    name: 'Cars under R450 000',
    link: '/used-cars/under-450000',
  },
  {
    id: 6009,
    name: 'Cars under R500 000',
    link: '/used-cars/under-500000',
  },
  {
    id: 6010,
    name: 'Cars over R500 000',
    link: '/used-cars/over-500000',
  },
];

export const locationOptionsDemo: NavigationFilter[] = [
  {
    id: 7001,
    name: 'Gauteng',
    link: '/demo/provinces/gauteng',
  },
  {
    id: 7002,
    name: 'KwaZulu-Natal',
    link: '/demo/provinces/kwazulu-natal',
  },
  {
    id: 7003,
    name: 'Western Cape',
    link: '/demo/provinces/western cape',
  },
  {
    id: 7004,
    name: 'Free State',
    link: '/demo/provinces/free-state',
  },
  {
    id: 7005,
    name: 'Northern Cape',
    link: '/demo/provinces/northern-cape',
  },
];

export const priceOptionsDemo: NavigationFilter[] = [
  {
    id: 8001,
    name: 'Cars under R100 000',
    link: '/demo/prices/under-100000',
  },
  {
    id: 8002,
    name: 'Cars under R150 000',
    link: '/demo/prices/under-150000',
  },
  {
    id: 8003,
    name: 'Cars under R200 000',
    link: '/demo/prices/under-200000',
  },
  {
    id: 8004,
    name: 'Cars under R250 000',
    link: '/demo/prices/under-250000',
  },
  {
    id: 8005,
    name: 'Cars under R300 000',
    link: '/demo/prices/under-300000',
  },
  {
    id: 8006,
    name: 'Cars under R350 000',
    link: '/demo/prices/under-350000',
  },
  {
    id: 8007,
    name: 'Cars under R400 000',
    link: '/demo/prices/under-400000',
  },
  {
    id: 8008,
    name: 'Cars under R450 000',
    link: '/demo/prices/under-450000',
  },
  {
    id: 8009,
    name: 'Cars under R500 000',
    link: '/demo/prices/under-500000',
  },
  {
    id: 8010,
    name: 'Cars over R500 000',
    link: '/demo/prices/over-500000',
  },
];
